import { styled } from "@mui/material/styles"

// eslint-disable-next-line import/prefer-default-export
export const StyledPage = styled("div")(() => ({
  display: "flex",
  flexDirection: "column"
}))
